<h1 mat-dialog-title>Anmelden als anderen Benutzer</h1>
<form [formGroup]="AuthentifikationForm">
    <mat-dialog-content>
        <h5>Anmelden als anderer Benutzer: {{ data.user.vorname }} {{ data.user.nachname }}</h5>

        <ng-container *ngIf="isLocalApi; else remoteTwoFa">
            <p>Lokale Entwicklung: 2FA wird übersprungen. Direkt anmelden?</p>
        </ng-container>

        <ng-template #remoteTwoFa>
            <div *ngIf="!twoFaGenerated">
                <button mat-flat-button color="primary" type="button" (click)="onGenerate2Fa()" [disabled]="generating">
                    2FA Generieren
                </button>
            </div>
            <div *ngIf="twoFaGenerated">
                <p>2FA Schlüssel wurde versendet.</p>
                <mat-form-field style="width: 100%">
                    <mat-label>2FA Authentifizierung</mat-label>
                    <input placeholder="2FA Schlüssel" matInput formControlName="AuthentKey" />
                </mat-form-field>
            </div>
        </ng-template>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-button type="button" (click)="closeDialog()" [disabled]="isLoading">Abbrechen</button>
        <button
            *ngIf="isLocalApi"
            mat-flat-button
            color="accent"
            type="button"
            (click)="confirmLocalSwap()"
            [disabled]="isLoading"
        >
            Direkt anmelden
        </button>
        <button
            *ngIf="!isLocalApi"
            mat-flat-button
            (click)="safeAndCloseDialog()"
            color="accent"
            type="submit"
            [disabled]="!twoFaGenerated || isLoading || AuthentifikationForm.invalid"
        >
            Anmelden
        </button>
    </mat-dialog-actions>
</form>
